import { render, staticRenderFns } from "./VesselAuditRecordMain.vue?vue&type=template&id=fa953290&scoped=true&"
import script from "./VesselAuditRecordMain.vue?vue&type=script&lang=js&"
export * from "./VesselAuditRecordMain.vue?vue&type=script&lang=js&"
import style0 from "./VesselAuditRecordMain.vue?vue&type=style&index=0&id=fa953290&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa953290",
  null
  
)

export default component.exports